import { SYNC_FORM_VALIDATION, SYNC_FORM_VALIDATION_REVIEW } from './';

export default (errors, bulk, reset = false) => (dispatch, getState) => {
  const { form: { selectedForm: { isActive } = {} } = {} } = getState();
  dispatch({
    type: isActive ? SYNC_FORM_VALIDATION : SYNC_FORM_VALIDATION_REVIEW,
    payload: { errors, bulk, reset },
  });
};
